
import { Component, Vue, Prop} from 'vue-property-decorator';

import StepBase from "../StepBase.vue";
import Executors from "./Executors.vue";
import SpouseInfo from "./spouseComponent/SpouseInfo.vue";
import ChildInfo from "./childComponent/ChildrenInfo.vue";
import Creditors from "./creditorComponent/Creditors.vue";
import Parents from "./Parents.vue";
import GrandChildren from "./GrandChildren.vue";
import GreatGrandChildren from "./GreatGrandChildren.vue";
import Beneficiaries from "./Beneficiaries.vue";

import { stepInfoType } from "@/types/Application";
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");


@Component({
    components:{
        StepBase,
        Executors,
        SpouseInfo,
        ChildInfo,
        Parents,
        GrandChildren,
        GreatGrandChildren,
        Beneficiaries,
        Creditors
    }
})

export default class RelatedPeopleStep extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;


};
